<template>
  <div>
    <b-container v-if="studentOpportunityAdditionalMaterialCopy">
        <content-block :contentId="contentId" v-if="contentId"></content-block>

        <b-row>
          <b-col sm="12">
            <b-alert :show="!prerequisitesComplete">
              {{ studentOpportunityAdditionalMaterialCopy.additionalMaterialType.prereqMessage }}
              <ul>
                <li v-for="prerequisite in studentOpportunityAdditionalMaterialCopy.additionalMaterialType.prerequisites" :key="prerequisite.additionalMaterialTypeId">
                  {{ prerequisite.name }}
                </li>
              </ul>
              Once these items are approved, you may complete this item.
            </b-alert>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="12">
            <b-alert :show="studentOpportunityAdditionalMaterialCopy.additionalMaterialType.generateDocument && !isOpen">
              {{ studentOpportunityAdditionalMaterialCopy.additionalMaterialType.closedMessage }}
            </b-alert>
          </b-col>
        </b-row>

        <b-row v-if="allowSubmission && studentOpportunityAdditionalMaterialCopy.additionalMaterialType.additionalMaterialTypeOptions.length">
          <b-col sm="12">
            
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="6">
            <h5>Latest submission</h5>
            <a :href="getFileHref(studentOpportunityAdditionalMaterialCopy.currentFile)"
              v-if="studentOpportunityAdditionalMaterialCopy.currentFile">
              {{ studentOpportunityAdditionalMaterialCopy.currentFile.fileName }}
            </a>
            <span class="current-status-name">
              {{ studentOpportunityAdditionalMaterialCopy.currentStatus.studentOpportunityAdditionalMaterialStatusDefinition.name }}
              <span v-if="studentOpportunityAdditionalMaterialCopy.currentStatus.studentOpportunityAdditionalMaterialStatusDefinition.name != 'Not Submitted'"> - {{ studentOpportunityAdditionalMaterialCopy.currentStatus.createdDate | formatDate }}</span>
            </span>
            <b-alert variant="warning" :show="studentOpportunityAdditionalMaterialCopy.currentStatus.studentOpportunityAdditionalMaterialStatusDefinition.preventResubmission">
              {{ studentOpportunityAdditionalMaterialCopy.currentStatus.studentOpportunityAdditionalMaterialStatusDefinition.resubmissionMessage }}
            </b-alert>
          </b-col>
          <b-col sm="6">
            <b-form inline class="pull-right mt-sm-2" v-if="allowSubmission && studentOpportunityAdditionalMaterialCopy.additionalMaterialType.additionalMaterialTypeOptions.length">
              <b-button v-b-modal="'generate-modal' + studentOpportunityAdditionalMaterialCopy.studentOpportunityAdditionalMaterialId" variant="primary flex-float-right" class="mt-sm-2" >{{modalButtonLabel}}</b-button>
            </b-form>
            <!-- <b-form inline class="pull-right mt-sm-2" v-if="allowSubmission">
              <label for="file-select" class="mr-sm-2" :class="{ 'invalid-label': $v.file.$error }">File</label>
              <b-form-file id="file-select" v-model="file" plain></b-form-file>
              <b-button variant="primary flex-float-right" class="mt-sm-2" @click="submitFile">Upload</b-button>
              <span class="span-feedback invalid-feedback" v-if="$v.file.$error">
                You must select a file.
              </span>
            </b-form> -->
          </b-col>

          <b-alert variant="success" :show="hasBeenApproved" class="mt-sm-2">This has been approved.</b-alert>
        </b-row>

        <b-collapse v-model="showMore" :id="'collapse' + studentOpportunityAdditionalMaterialCopy.studentOpportunityAdditionalMaterialId">
          <h5 class="mt-2">All submission</h5>
          <div v-for="file in  studentOpportunityAdditionalMaterialCopy.studentOpportunityAdditionalMaterialFiles"
              :key="file.studentOpportunityAdditionalMaterialFileId">
              <a :href="getFileHref(file)">
                {{ file.fileName }} - {{ file.createdDate | formatDate }}
              </a>
          </div>
        </b-collapse>
      
    </b-container>
    <div class="accordion-control" v-if="studentOpportunityAdditionalMaterialCopy.studentOpportunityAdditionalMaterialFiles.length > 0">
      <a href="" @click.prevent="showMore = !showMore">{{showMore ? 'Show less' : 'Show more'}}</a>
    </div>
    <b-modal :id="'generate-modal' + studentOpportunityAdditionalMaterialCopy.studentOpportunityAdditionalMaterialId" 
             :title="modalButtonLabel"
             v-model="show"
             hide-footer
             @hide="hide">

      <!-- add v-for here for various components -->
      <div v-for="(option, index) in studentOpportunityAdditionalMaterialCopy.additionalMaterialType.additionalMaterialTypeOptions" 
          :key="option.additionalMaterialTypeOptionId"
          v-show="step === index">
        <dynamic-wrapper :component-name="option.additionalMaterialOption.name" @submitted="next()" @previous="previous()" 
          :option="option.additionalMaterialOption"
          v-bind:studentOpportunityAdditionalMaterialId="studentOpportunityAdditionalMaterialCopy.studentOpportunityAdditionalMaterialId"
          v-bind:studentOpportunityId="studentOpportunityCopy.studentOpportunityId"
          :asuriteId="userId"
          :callback="submittedNotification.actionEvent"
          :isFirst="index == 0"
          :isLast="index == studentOpportunityAdditionalMaterialCopy.additionalMaterialType.additionalMaterialTypeOptions.length - 1"></dynamic-wrapper>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import placementsApi from "../../api/placements/opportunities";
import toastr from "toastr";
import ToastrSettings from "../../settings/toastr-settings";
import { required } from "vuelidate/lib/validators";
import contentBlock from "../content/content-block";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars
import dynamicWrapper from "../placements/dynamic-wrapper";

export default {
  data() {
    return {
      // make a copy to avoid mutating props
      studentOpportunityAdditionalMaterialCopy: null,
      studentOpportunityCopy: null,
      statusId: null,
      file: null,
      showMore: false,
      contentId: null,
      show: false,
      contact: {},
      goals: [],
      submitted: false,
      step: 0
    };
  },

  components: {
    "content-block": contentBlock,
    "dynamic-wrapper": dynamicWrapper
  },

  props: {
    studentOpportunityAdditionalMaterial: {
      type: Object,
      require: true
    },
    supervisors: {
      required: false,
      type: Array
    },
    userId: {
      required: true,
      type: String
    },
    studentOpportunity: {
      required: true,
      type: Object
    }
  },

  validations: {
    file: {
      required
    }
  },

  watch: {
    studentOpportunityAdditionalMaterial: function() {
      this.studentOpportunityAdditionalMaterialCopy = this.studentOpportunityAdditionalMaterial;
      this.statusId = this.studentOpportunityAdditionalMaterial.currentStatus.studentOpportunityAdditionalMaterialStatusDefinitionId;
      this.contentId = this.studentOpportunityAdditionalMaterialCopy.additionalMaterialType.description;
    },
    studentOpportunity: function() {
      this.studentOpportunityCopy = this.studentOpportunity;
      this.goals = this.studentOpportunity.goals;
      if (this.studentOpportunity.supervisors.length) {
        this.contact = this.studentOpportunity.supervisors[0].siteContact;
      }
    }
  },

  computed: {
    submittedNotification: function() {
      const submittedNotification = _.filter(this.studentOpportunityAdditionalMaterialCopy.additionalMaterialType.notifications, notification => {
        return notification.status.name === "Submitted";
      });
      // only get the first entry if there is more than one configured
      if(submittedNotification.length) {
        return submittedNotification[0];
      }
      return [];
    },
    modalButtonLabel: function() {
      if (this.studentOpportunityAdditionalMaterialCopy.actionLabel) {
        return this.studentOpportunityAdditionalMaterialCopy
          .additionalMaterialType.actionLabel;
      }
      return this.studentOpportunityAdditionalMaterialCopy
        .additionalMaterialType.name;
    },
    hasBeenApproved: function() {
      return (
        this.studentOpportunityAdditionalMaterialCopy.currentStatus
          .studentOpportunityAdditionalMaterialStatusDefinition.name ===
        "Approved"
      );
    },
    isOpen: function() {
      var termStart = new Date(this.studentOpportunityCopy.termStart);

      var open = null;
      if (
        this.studentOpportunityAdditionalMaterialCopy.additionalMaterialType
          .openDate
      ) {
        open = new Date(termStart);
        open.setDate(
          open.getDate() +
            this.studentOpportunityAdditionalMaterialCopy.additionalMaterialType
              .openDate
        );
      } else {
        open = new Date(-8640000000000000);
      }

      var close = null;
      if (
        this.studentOpportunityAdditionalMaterialCopy.additionalMaterialType
          .closeDate
      ) {
        close = new Date(termStart);
        close.setDate(
          close.getDate() +
            this.studentOpportunityAdditionalMaterialCopy.additionalMaterialType
              .closeDate
        );
      } else {
        close = new Date(8640000000000000);
      }

      var today = new Date().getTime();

      if (open <= today && today <= close) {
        return true;
      }
      return false;
    },
    prerequisitesComplete: function() {
      var that = this;
      var complete = true;
      if (
        this.studentOpportunityAdditionalMaterialCopy.additionalMaterialType
          .prerequisites.length
      ) {
        // iterate each prereq for the item and determine if it has been completed
        _.forEach(
          this.studentOpportunityAdditionalMaterialCopy.additionalMaterialType
            .prerequisites,
          function(prerequisite) {
            // find item status
            var item = _.find(
              that.studentOpportunityCopy.studentOpportunityAdditionalMaterials,
              mat => {
                return (
                  mat.additionalMaterialTypeId ==
                  prerequisite.additionalMaterialTypeId
                );
              }
            );
            if (!item) {
              // if the item wasn't found, ignore it.
              complete = true;
            } else if (
              !item.currentStatus.studentOpportunityAdditionalMaterialStatusDefinition.name.includes(
                "Approved"
              )
            ) {
              complete = false;
            }
          }
        );
        return complete;
      }
      return true;
    },
    allowSubmission: function() {
      // can't submit if status prevents resubmission
      if (
        this.studentOpportunityAdditionalMaterialCopy.currentStatus
          .studentOpportunityAdditionalMaterialStatusDefinitionId
          .preventResubmission
      ) {
        return false;
      }

      // can't submit if prerequisites not complete
      else if (!this.prerequisitesComplete) {
        return false;
      }

      // can't submit if is not open
      else if (
        this.studentOpportunityAdditionalMaterialCopy.additionalMaterialType
          .generateDocument &&
        !this.isOpen
      ) {
        return false;
      } else {
        return true;
      }
    },
    openDate: function() {
      if (
        this.studentOpportunityAdditionalMaterialCopy.additionalMaterialType
          .openDate
      ) {
        var open = new Date(this.studentOpportunityCopy.termStart);
        open.setDate(
          open.getDate() +
            this.studentOpportunityAdditionalMaterialCopy.additionalMaterialType
              .openDate
        );
        return open;
      } else {
        return new Date(-8640000000000000);
      }
    }
  },

  methods: {
    ...mapActions("placements", [
      "postFile",
      "toggleRefresh",
      "generateAdditionalMaterialDocument",
      "sendILASubmissionEmail"
    ]),
    ...mapActions("additionalMaterials", [
      "setGoals",
      "setUserId",
      "setStudentOpportunityId",
      "setStudentOpportunityAdditionalMaterialId",
      "setContact",
      "setStudentOpportunity",
      "setStudentOpportunityAdditionalMaterial",
      "setSupervisors",
      "reset"
    ]),
    next: function() {
      if (
        this.step + 1 <
        this.studentOpportunityAdditionalMaterialCopy.additionalMaterialType
          .additionalMaterialTypeOptions.length
      ) {
        this.step++;
      } else {
        // Toastr Message
        toastr.options = ToastrSettings;
        toastr.success("Submitted successfully.", "Success");
        this.show = false;
      }
    },
    previous: function() {
      if (this.step > 0) {
        this.step--;
      }
    },
    hide: function() {
      this.step = 0;
      this.$emit("refresh");
    },
    getFileHref: function(file) {
      if (this.studentOpportunityAdditionalMaterialCopy.currentFile) {
        return (
          process.env.VUE_APP_BASE_URI +
          "/api/Downloads/StudentAdditionalMaterialFile?id=" +
          file.studentOpportunityAdditionalMaterialFileId
        );
      }
      return "";
    },
  },

  created() {
    this.reset();
    this.studentOpportunityCopy = this.studentOpportunity;
    this.studentOpportunityAdditionalMaterialCopy = this.studentOpportunityAdditionalMaterial;
    this.statusId = this.studentOpportunityAdditionalMaterial.currentStatus.studentOpportunityAdditionalMaterialStatusDefinitionId;
    this.contentId = this.studentOpportunityAdditionalMaterialCopy.additionalMaterialType.description;
    this.goals = this.studentOpportunity.goals;
    this.setGoals(this.studentOpportunity.goals);
    this.setUserId(this.userId);
    this.setStudentOpportunityId(this.studentOpportunity.studentOpportunityId);
    this.setStudentOpportunityAdditionalMaterialId(
      this.studentOpportunityAdditionalMaterial
        .studentOpportunityAdditionalMaterialId
    );
    this.setStudentOpportunity(this.studentOpportunityCopy);
    this.setStudentOpportunityAdditionalMaterial(
      this.studentOpportunityAdditionalMaterialCopy
    );
    if (this.studentOpportunity.supervisors.length) {
      this.contact = this.studentOpportunity.supervisors[0].siteContact;
      this.setContact(this.studentOpportunity.supervisors[0].siteContact);
    }
    this.setSupervisors(this.supervisors);
  }
};
</script>

<style scoped>
h5 {
  font-size: 0.9em;
}

label {
  font-weight: bold;
}

.form-control-file {
  width: 70%;
}

.flex-float-right {
  margin-left: auto;
}

.invalid-label {
  color: #dc3545;
}

.alert-success {
  width: 100%;
}

.accordion-control {
  width: 100%;
  text-align: center;
  background-color: #e9e9e9;
  border: 1px solid #d1d2d3;
  margin-top: 1em;
}
</style>
